module.exports = __webpack_public_path__ + "img/mobile-fire-logo.970c78a5.jpg";